export default __webpack_public_path__ + "static/media/3071357.c0d9fe85.jpg";